import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { Store } from '@/store';

export const baseApiAuthenticated = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: '/',
        prepareHeaders: (headers, { getState, endpoint }) => {
            if (endpoint !== 'postLogin') {
                const token = (getState() as Store).authSlice?.jwt;

                // If we have a token set in state, let's assume that we should be passing it.
                if (token) {
                    headers.set('Authorization', `bearer ${token}`);
                }
            }

            return headers;
        },
    }),

    endpoints: () => ({}),
});

// Voucher, FAQ, and Ticket endpoints are now auto-injected via createEntityApi pattern
// They are automatically injected when the entity packages are imported
